// import { useGlobalStore } from "@/store/useGlobalStore";
// import empresaService from "@/services/empresaService";
// import parametroService from "@/services/parametroService";

// export default async function carregarDadosDoMenu(to, from, next) {
//   const store = useGlobalStore();
//   store.carregando = true;

//   try {
//     // Recupera o CNPJ logado da store ou localStorage
//     const cnpj = store.cnpjLogado || localStorage.getItem("cnpj");

//     if (!cnpj) {
//       console.warn("CNPJ não encontrado, redirecionando para login");
//       return next("/login");
//     }

//     // Chama a API e espera o retorno
//     const empresa = await empresaService.buscarEmpresa(cnpj);
//     // Se não veio empresa, redireciona para erro
//     if (!empresa) {
//       console.warn("Empresa não encontrada para o CNPJ:", cnpj);
//       return next("/erro");
//     }

//     const parametro = await parametroService.buscarParametro(
//       empresa[0].idEmpresa
//     );

//     // Salva a empresa na store global
//     store.definirObjetoEmpresaLogada(empresa[0]);
//     store.atualizarObjParametro(parametro);
//     // Continua para a rota
//     return next();
//   } catch (erro) {
//     console.error("Erro ao carregar dados do menu:", erro);
//     return next("/erro");
//   } finally {
//     store.carregando = false;
//   }
// }
import { useGlobalStore } from "@/store/useGlobalStore";
import empresaService from "@/services/empresaService";
// planosService NÃO é importado aqui no topo para evitar dependência circular:
// planosService → baseService → apiClient → router → carregarDadosDoMenu → planosService

export default async function carregarDadosDoMenu(to, from, next) {
  const store = useGlobalStore();

  // Verificar se token expirou
  if (store.tokenExpirou) {
    store.desautenticar();
    return next("/login");
  }

  // Restaurar cnpjLogado do localStorage caso o store tenha sido resetado (ex: reload)
  if (!store.cnpjLogado) {
    const cnpjSalvo = localStorage.getItem("cnpj_logado");
    if (cnpjSalvo) {
      store.definirCnpjLogado(cnpjSalvo);
    }
  }

  // Se já tem empresa carregada nesta sessão
  if (store.empresaLogada?.idEmpresa || store.empresaLogada?.[0]?.idEmpresa) {
    const cnpj = store.cnpjLogado;
    // Busca menus da API se ainda não foram carregados nesta sessão JS.
    // Usa a flag em memória (não sessionStorage) para evitar menus velhos
    // quando o Chrome restaura a aba com sessionStorage da sessão anterior.
    if (!store.menusCarregadosDaApi && cnpj) {
      try {
        const { default: planosService } = await import(
          "@/services/planosService"
        );
        const itens = await planosService.buscarMenuAcessos(cnpj);
        if (Array.isArray(itens) && itens.length > 0) {
          store.definirMenus(itens);
        } else {
          // API retornou vazio — usa catálogo estático como garantia
          store.construirMenusDeFallback();
        }
      } catch {
        // API falhou — usa catálogo estático para não deixar menu em branco
        store.construirMenusDeFallback();
      }
    }
    return next();
  }

  // Sem CNPJ e sem empresa → redirecionar para login
  if (!store.cnpjLogado) {
    return next("/login");
  }

  try {
    const empresa = await empresaService.buscarEmpresa(store.cnpjLogado);
    const emp = Array.isArray(empresa) ? empresa[0] : empresa;
    store.definirObjetoEmpresaLogada(emp);

    // Funcionalidades do objeto empresa como fallback (backward compat)
    const funcsEmpresa = emp?.funcionalidades ?? "";
    if (funcsEmpresa) store.definirFuncionalidades(funcsEmpresa);

    // Busca os itens de menu completos do banco (fonte de verdade)
    try {
      const { default: planosService } = await import(
        "@/services/planosService"
      );
      const itens = await planosService.buscarMenuAcessos(store.cnpjLogado);
      if (Array.isArray(itens) && itens.length > 0) {
        store.definirMenus(itens);
      } else {
        // API retornou vazio — usa catálogo estático + funcionalidades da empresa
        store.construirMenusDeFallback();
      }
    } catch {
      // Endpoint falhou — usa catálogo estático para não deixar menu em branco
      store.construirMenusDeFallback();
    }

    next();
  } catch (erro) {
    if (erro.response?.status === 401) {
      store.desautenticar();
      next("/login");
    } else {
      // Erro de rede / API indisponível — tenta fallback e libera navegação
      // para evitar loop infinito: /inicio → /erro → /login → /inicio
      console.warn("[Menu] Empresa não carregada:", erro.message);
      store.construirMenusDeFallback();
      next();
    }
  }
}
